'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'sword';
var width = 512;
var height = 512;
var aliases = [128481];
var unicode = 'f71c';
var svgPathData = ['M200.6 283.3c9.4 9.4 18.7 18.7 28.1 28.1L450.7 89.4l4.7-32.8-32.8 4.7L200.6 283.3z', 'M200.6 283.3l-33.9-33.9L400 16l62.5-8.9L512 0l-7.1 49.5L496 112 262.6 345.4l-33.9-33.9L450.7 89.4l4.7-32.8-32.8 4.7L200.6 283.3zM0 416l32-32 32 16 56-56L64 256l32-32L288 416l-32 32-88-56-56 56 16 32L96 512 0 416z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSword = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;